<template>
	<v-responsive style="overflow: visible">
		<div class="d-flex flex-column mb-4">
			<a v-if="!finalStep" :href="portalUrl">
				<rmp-icon height="30" :color="colors.secondary.base" src="ico_logo"></rmp-icon>
			</a>
			<rmp-text :color="colors.secondary.base" type="title-medium" class="mt-8">{{ title }}</rmp-text>
		</div>
		<slot></slot>
	</v-responsive>
</template>

<script setup lang="ts">
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import RmpIcon from "@rmp/core/components/icon/RmpIcon.vue";
import { RouteNames } from "@rmp/id/router/routes";
import { useMasterAccountAccessStore } from "@rmp/id/stores/masterAccountAccess";
import { storeToRefs } from "pinia";
import { useColors } from "@rmp/core/composables/useColors";

const useStore = useMasterAccountAccessStore;
const store = useStore();

const { colors } = useColors();

let {
	finalStep
} = storeToRefs(store);

export interface Props {
	title: string;
	preventBackStep?: boolean;
}

defineProps<Props>();

const portalUrl = process.env.VUE_APP_PORTAL_BASE_URL;
</script>

<style scoped>

</style>
